import { type ChallengeState, createChallengeState } from "@msidentity/SISU/challenge-context";
import { Flavors, FlowId } from "@msidentity/SISU/constants";
import { type BaseSisuStateFabric } from "@msidentity/SISU/context/sisu-providers";
import { initBaseSisuAppDataFabric } from "@msidentity/SISU/context/sisu-providers/fabric/init-base-sisu-app-data-fabric";
import { initExp } from "@msidentity/SISU/utilities/client-experimentation/client-experiment-helper";
import { type ServerData } from "@msidentity/SISU/utilities/server-data";
import {
  type UsernameRecoveryState,
  createUsernameRecoveryState,
} from "../../flows/username-recovery/username-recovery-context";
/**
 * Parse the ServerData object sent from Account and return the initial config/state for the app contexts.
 * IMPORTANT: This should be called at module scope, NOT inside the render function!!
 * @param serverData The ServerData object sent from the Account server and read from the window object.
 * @param activeFlavor The rendered flavor
 * @param activeFlow The rendered flow
 * @returns The initial state for the global and signup contexts.
 */
export function initUsernameRecoveryAppFabric(
  serverData: ServerData,
  activeFlavor: Flavors,
  activeFlow: FlowId,
): {
  initialUsernameRecoveryState: UsernameRecoveryState;
  initialChallengeState: ChallengeState;
  initialProviderState: BaseSisuStateFabric;
} {
  const initialProviderState = initBaseSisuAppDataFabric(serverData, activeFlavor, activeFlow);
  const initialChallengeState = createChallengeState(serverData);
  const initialUsernameRecoveryState = createUsernameRecoveryState(serverData);

  initExp(Flavors.Fabric, FlowId.UsernameRecovery);

  return {
    initialUsernameRecoveryState,
    initialChallengeState,
    initialProviderState,
  };
}
